import { render } from "./ProposalAlmostPublishModal.vue?vue&type=template&id=93444958"
import script from "./ProposalAlmostPublishModal.vue?vue&type=script&lang=js"
export * from "./ProposalAlmostPublishModal.vue?vue&type=script&lang=js"

import "./ProposalAlmostPublishModal.vue?vue&type=style&index=0&id=93444958&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__